module.exports = __webpack_public_path__ + "img/li1.1d078733.jpg";